export type AppVersion = "v1" | "v2";

const SOLICITUDES_HOME: Record<AppVersion, string> = {
    v1: "/solicitudes",
    v2: "/v2/solicitudes",
};

/**
 * Traduce el pathname actual al equivalente en la versión destino, para que
 * el usuario no pierda su ubicación al cambiar de versión (v1 <-> v2).
 * Los prefijos de ruta no son simétricos entre versiones (p.ej. "reporteria"
 * pasa a "v2/reportes"), y algunos segmentos sólo existen en una versión.
 */
export const getVersionSwitchPath = (pathname: string, targetVersion: AppVersion): string => {
    const solicitudMatch = pathname.match(/^\/(?:v2\/)?solicitud\/([^/]+)\/([^/]+)(?:\/([^/]+))?/);
    if (solicitudMatch) {
        const [, companyName, id, segment] = solicitudMatch;

        if (targetVersion === "v2") {
            return `/v2/solicitud/${companyName}/${id}${segment ? `/${segment}` : ""}`;
        }

        if (!segment || segment === "contratos") {
            return `/solicitud/${companyName}/${id}`;
        }
        return `/solicitud/${companyName}/${id}/${segment}`;
    }

    if (pathname === "/solicitudes" || pathname === "/v2/solicitudes") {
        return SOLICITUDES_HOME[targetVersion];
    }

    const reporteriaMatch = pathname.match(/^\/reporteria(?:\/([^/]+))?/);
    if (reporteriaMatch) {
        const segment = reporteriaMatch[1];
        return segment === "solicitudes" ? "/v2/reportes/solicitudes" : "/v2/reportes";
    }

    const reportesV2Match = pathname.match(/^\/v2\/reportes(?:\/([^/]+))?/);
    if (reportesV2Match) {
        const segment = reportesV2Match[1];
        return segment === "solicitudes" ? "/reporteria/solicitudes" : "/reporteria";
    }

    if (pathname === "/admin" || pathname.startsWith("/admin/")) return pathname;
    if (pathname === "/dashboards" || pathname.startsWith("/dashboards/")) return pathname;

    return SOLICITUDES_HOME[targetVersion];
};
